import { render, staticRenderFns } from "./ImportsHome.vue?vue&type=template&id=11fb4c46"
import script from "./ImportsHome.vue?vue&type=script&lang=js"
export * from "./ImportsHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports